import ToolbarButton from './ToolbarButton';
import ToolbarDivider from './ToolbarDivider';

import { faKey } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function SolutionsControls({ blockData, onUpdateBlockData }) {
  function toggleSolution(toggleOn = true) {
    onUpdateBlockData({ solution: toggleOn });
  }

  const solution = !!(blockData && blockData.get('solution'));

  return (
    <>
      <ToolbarButton active={!!solution} onToggle={toggleSolution} toggleKey={!solution} tooltip="toggle solution">
        <FontAwesomeIcon icon={faKey} />
      </ToolbarButton>
      <ToolbarDivider />
    </>
  );
}
